import { useFilters } from '../context/FilterContext';
import { useApi } from '../hooks/useApi';
import PlayerTable from '../components/PlayerTable';

export default function Players() {
  const { region, step } = useFilters();
  const { data, loading } = useApi('/api/top-scorers?limit=500');

  let players = data?.stats || [];

  if (region) players = players.filter((p) => p.region_name === region);
  if (step) players = players.filter((p) => String(p.step_number) === step);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <span className="material-symbols-outlined text-4xl text-primary animate-spin">progress_activity</span>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <header>
        <p className="font-label text-[11px] font-semibold uppercase tracking-[0.12em] text-on-surface-variant">
          Player Database
        </p>
        <h2 className="font-expanded font-headline text-3xl sm:text-4xl font-bold tracking-tight text-on-surface mt-1">
          All Players
        </h2>
        <p className="mt-2 text-sm text-on-surface-variant">
          {players.length} players tracked{region || step ? ' · filters applied' : ''}
        </p>
      </header>
      <div className="bg-surface-container rounded-xl border border-outline-variant/30 overflow-hidden">
        <PlayerTable players={players} />
      </div>
    </div>
  );
}
